import { useState, useEffect, useContext } from "react";
import { ColDef, ValueFormatterParams } from "ag-grid-community";
import AgGridModalLayout from "@wrappers/layouts/AgGridModalLayout";
import { mainContext } from "@ts/constants";
import moment from "moment";
import { Alert, IMainContext, TOverviewGrid } from "@ts/common-types";
import AlertsCellRenderer from "@/components/cell-renderers/AlertsCellRenderer";

const AlertsGrid: React.FC<TOverviewGrid> = ({ componentType }) => {
    const { setAlertsGridApi, alertsData } =
        useContext<IMainContext>(mainContext);
    const [rowData, setRowData] = useState<Alert[]>(alertsData);
    const [gridHeight, setGridHeight] = useState<number>();

    useEffect(() => {
        setRowData(alertsData);
    }, [alertsData]);

    const dateFormatter = (params: ValueFormatterParams) => {
        return moment(params.data.date, "YYYY-MM-DDTHH:mm:ss").format(
            "YYYY-MM-DD"
        );
    };

    const timeFormatter = (params: ValueFormatterParams) => {
        return moment(params.data.date, "YYYY-MM-DDTHH:mm:ss").format("HH:mm");
    };

    const [columnDefs] = useState<ColDef[]>([
        {
            field: "date",
            headerName: "Date",
            filter: "agDateColumnFilter",
            sortable: true,
            valueFormatter: dateFormatter,
        },
        {
            field: "time",
            headerName: "Time",
            filter: "agDateColumnFilter",
            sortable: true,
            hide: true,
            valueFormatter: timeFormatter,
        },
        {
            field: "sku",
            headerName: "SKU",
            filter: "agTextColumnFilter",
            sortable: true,
        },
        {
            field: "title",
            headerName: "Title",
            filter: "agTextColumnFilter",
            sortable: true,
            tooltipField: "title",
            maxWidth: 500,
        },
        {
            field: "type",
            headerName: "Type",
            filter: "agTextColumnFilter",
            sortable: true,
        },
        {
            field: "from",
            headerName: "From",
            filter: "agTextColumnFilter",
            sortable: true,
            cellRenderer: AlertsCellRenderer
        },
        {
            field: "to",
            headerName: "To",
            filter: "agTextColumnFilter",
            sortable: true,
            cellRenderer: AlertsCellRenderer
        },
    ]);

    return (
        <div
            className="ag-theme-alpine"
            id="alerts-reports-grid"
            style={
                componentType === "table"
                    ? { height: "20rem" }
                    : { height: `${gridHeight}px` }
            }
        >
            <AgGridModalLayout
                rowData={rowData}
                setGridApi={setAlertsGridApi}
                columnDefs={columnDefs}
                pagination={true}
                isTotalRowsReq={false}
                setGridHeight={setGridHeight}
            ></AgGridModalLayout>
        </div>
    );
};

export default AlertsGrid;
